import React, { Component } from 'react';
import {
  Modal,
  Input,
  Divider,
  Avatar,
  message,
  Popconfirm,
  Typography,
  Button,
} from 'antd';
import { addLikeToStandup } from '../skills_action';
import { connect } from 'react-redux';
import { instances } from 'chart.js';

const { Text } = Typography;

class AwaitingModel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  sendReminderToAll = () => {
    let allUserIds = [];
    this.props.instanceResponses.forEach((instance) => {
      if (instance.status == 'asked') {
        allUserIds.push(instance.user_id._id);
      }
    });
    // console.log(allUserIds)
    this.props.sendReminder(allUserIds);
  };
  render() {
    let disabledMarkOnLeaveBtn = !(
      this.props.isAdmin || this.props.isTeamSyncAdmin
    )
      ? true
      : false;
    // console.log('disabled',(!this.props.isAdmin && !this.props.isTeamSyncAdmin))
    let unrespondedCount = 0;
    let getUnrespondedUsersName = this.props.instanceResponses.map(
      (instance) => {
        let unrespondedUsername =
          instance.user_id.displayName || instance.user_id.name;
        if (instance.status == 'asked') {
          unrespondedCount++;
          return (
            <div
              style={{
                marginBottom: 8,
                justifyContent: 'space-between',
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div>
                <Text style={{ marginRight: 8, width: '50%' }}>
                  {unrespondedUsername}
                </Text>
              </div>
              <div style={{ marginRight: 8, float: 'right' }}>
                <Button
                  type='link'
                  onClick={() =>
                    this.props.sendReminder([instance.user_id._id])
                  }
                  style={{ marginRight: 8 }}
                >
                  Remind
                </Button>
                {/* <Button type="link" onClick={() => this.props.markOnLeave(instance)} style={{ marginRight: 8 }}>
                             Mark Leave
                         </Button> */}
                <Popconfirm
                  title={() => this.props.getPopconfirmTitleLeave()}
                  onConfirm={() => this.props.markOnLeave(instance)}
                  onCancel={() => this.props.handleSelectionCancel()}
                  placement='rightTop'
                >
                  <Button
                    type='link'
                    style={{ marginRight: 8 }}
                    size='small'
                    disabled={disabledMarkOnLeaveBtn}
                  >
                    Mark on Leave
                  </Button>
                </Popconfirm>
              </div>
            </div>
          );
        }
      }
    );

    return (
      <Modal
        title={<b>Awaiting Responses</b>}
        visible={this.props.showModal}
        // onOk={}
        // okText={}
        footer={null}
        onCancel={this.props.handleCancel}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <Text strong style={{ marginRight: 8 }}>
              {`${unrespondedCount} participants are yet to respond`}
              {/* {`${this.props.getUnrespondedUsers()} participants are yet to respond`} */}
            </Text>
            <Popconfirm
              title={`Are you sure you want to remind ${unrespondedCount} participants?`}
              onConfirm={() => this.sendReminderToAll()}
              okText='Yes'
            >
              <Button type='link'>Remind All</Button>
            </Popconfirm>
          </div>
          <Divider style={{ margin: '12px 0px 8px' }} />
          <div style={{ maxHeight: 300, overflow: 'auto', width: '100%' }}>
            {getUnrespondedUsersName}
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect(null, { addLikeToStandup })(AwaitingModel);
